import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Country, EventItem, Lookups} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {LocalizedDatePipe} from "@pipes";
import {AbstractComponent, MyUpcomingHeadingType} from "@components";

@Component({
  selector: 'app-my-upcoming-event',
  templateUrl: './my-upcoming-event.component.html',
  styleUrl: './my-upcoming-event.component.scss',
  animations: [
    trigger('toBottom', [
      state('in', style({height: '*'})),
      transition(':enter', [
        style({height: '0', overflow: 'hidden'}),
        animate('300ms ease-out', style({height: '*'}))
      ]),

      state('out', style({height: '0'})),
      transition(':leave', [
        style({height: '*', overflow: 'hidden'}),
        animate('300ms ease-out', style({height: '0'}))
      ])
    ])]
})
export class MyUpcomingEventComponent extends AbstractComponent implements OnInit{
  @Input() event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];


  localizedDatePipe: LocalizedDatePipe;
  isExpanded: boolean = false;

  constructor(public translocoService: TranslocoService, @Inject(PLATFORM_ID) private platformId: Object) {
    super();
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }


  ngOnInit() {
  }

  expand() {
    this.isExpanded = !this.isExpanded;
  }

  protected readonly MyUpcomingHeadingType = MyUpcomingHeadingType;



}
